import c from "../../utils/constants";

class JobsController {
  constructor(JobsService, FilterService, AuthService, $scope) {
    "ngInject"

    this.jobsService = JobsService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  getGridOptions() {

    return {
      dataSource: this.jobsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No match found. Change your filter criteria."
      },
      columns: [
        {
          field: "postDate", title: "Posted On", filterable: false, width: "4rem",
          template: `<span>#= kendo.toString(new Date(postDate), 'dd-MM-yyyy') #</span>`,
        },
        { field: "jobType", title: "Job Type", filterable: false, sortable: false, width: "8rem", template: (dataItem) => `${this._getJobTypeText(dataItem.jobType)}` },
        { field: "jobReference", title: "Job Reference", filterable: false, sortable: false, width: "4rem", template: (dataItem) => this._getJobReferenceCell(dataItem) },
        { field: "jobStatus", title: "Status", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getJobStatusText(dataItem.jobStatus)}` },
        { field: "totalInvites", title: "Helper Stats", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getHelperStats(dataItem)}` },
        { field: "totalInvites", title: "Open Rate", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getOpenRate(dataItem)}` },
        { field: "managedBy", title: "Mgmt", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getManagedByText(dataItem.managedBy)}` },
        { field: "estimatedJobValue", title: "Job Value", filterable: false, sortable: false, width: "4rem", template: (dataItem) => kendo.toString(dataItem.estimatedJobValue, 'c0') },
        {
          field: "ownerFullName", title: "Job Owner", filterable: false, sortable: false,width: "8rem",
          template: `<a class="cell" href="#= '/users/' + ownerUserId #">#= ownerFullName #</a>`,
        },
        {
          field: "addressState", title: "State", filterable: false, width: "4rem",
          template: `<span>#= (country === 'au' ? addressState.toUpperCase() : addressState) #</span>`,
        },
        // {
        //   field: "ownerUserId", title: "User Id", filterable: false, sortable: false,width: "4rem",
        // },
        {
          field: "jobDate", title: "Start Date", filterable: false, width: "4rem",
          template: `<span>#= kendo.toString(new Date(jobDate), 'dd-MM-yyyy') #</span>`,
        },
        // {
        //   field: "jobFinishDate", title: "Finish Date", filterable: false, sortable: false, width: "4rem",
        //   template: `<span>#= jobType != 1 ? kendo.toString(new Date(jobFinishDate), 'dd-MM-yyyy') : "-" #</span>`,
        // },
        {
          field: "expirationDate", title: "Expiry Date", filterable: false, sortable: false, width: "4rem",
          template: `<span>#= kendo.toString(new Date(expirationDate), 'dd-MM-yyyy') #</span>`,
        },
        { field: "ownerNumberOfPostedJobs", title: "# Jobs", filterable: false, sortable: false, width: "5rem" },
      ]
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.jobsMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  // Links always use the internal ID; only the label shows the user-facing reference.
  _getJobReferenceCell(dataItem) {
    const reference = kendo.htmlEncode(dataItem.jobReference || String(dataItem.id));
    let cell = `<a class="cell" href="/jobs/${dataItem.id}">${reference}</a>`;

    if (dataItem.isRepost && dataItem.relatedJobId) {
      const originalReference = kendo.htmlEncode(dataItem.relatedJobReference || String(dataItem.relatedJobId));
      cell += `<div class="repost-of">Repost of <a class="cell" href="/jobs/${dataItem.relatedJobId}">${originalReference}</a></div>`;
    }

    return cell;
  }

  _getHelperStats(dataItem) {
    return dataItem.activeInvites + " / "  + dataItem.totalInvites;
  }

  _getOpenRate(dataItem) {
    const activity = dataItem.activeInvites + " / "  + dataItem.totalInvites;
    const openRate = dataItem.activeInvites / dataItem.totalInvites;
    return kendo.format('{0:p0}', openRate);
  }

  _getJobTypeText(type) {
    switch(type) {
      case c.jobType.BABYSITTING:
        return "Babysitting";
      case c.jobType.NANNYING:
        return "Nannying";
      case c.jobType.AFTER_SCHOOL_CARE:
        return "After School Care";
      case c.jobType.BEFORE_SCHOOL_CARE:
        return "Before School Care"
      case c.jobType.BEFORE_AFTER_SCHOOL_CARE:
        return "Before/After School Care";
      case c.jobType.AU_PAIR:
        return "Au Pair";
      case c.jobType.PRIMARY_SCHOOL_TUTORING:
        return "Primary School Tutoring";
      case c.jobType.HIGH_SCHOOL_TUTORING:
        return "High School Tutoring";
      case c.jobType.ONE_OFF_ODD_JOBS:
        return "Odd Job";
    }
  }

  _getJobStatusText(status) {
    switch(status) {
      case c.jobStatus.PENDING:
        return "Pending";
      case c.jobStatus.AWARDED:
        return "Awarded";
      case c.jobStatus.CANCELLED:
        return "Cancelled";
      case c.jobStatus.COMPLETED:
        return "Completed"
      case c.jobStatus.FILLED:
        return "Filled";
      case c.jobStatus.FILLED_AND_CANCELLED:
        return "Filled and Closed";
    }
  }

  _getManagedByText(status) {
    switch (status) {
      case c.managedBy.USER:
        return "DIY";
      case c.managedBy.SYSTEM:
        return "Assist";
    }

    return "";
  }

}

export default JobsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/jobs/jobs.controller.js
 **/